/* Shiny Leaf PDP fixes (Oct 2026): show the selected size's image when a supply option is chosen */
(function(){
  function sized(u, w){ u = u.replace(/^https?:/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function initVariantImages(){
    document.querySelectorAll('[data-slp-root]').forEach(function(root){
      if (root.__slpVarImg) return;
      var plans = root.querySelectorAll('[data-slp-plan]');
      var slide = root.querySelector('[data-slp-slide="0"]');
      if (!plans.length || !slide) return;
      root.__slpVarImg = true;
      var img = slide.querySelector('img');
      var thumb = root.querySelector('[data-slp-thumb="0"]');
      var timg = thumb && thumb.querySelector('img');
      var simg = root.querySelector('[data-slp-sticky] img');
      var path = location.pathname.replace(/\/$/, '');
      fetch(path + '.js').then(function(r){ return r.json(); }).then(function(p){
        var map = {};
        (p.variants || []).forEach(function(v){ if (v.featured_image && v.featured_image.src) map[v.id] = v.featured_image.src; });
        function apply(btn){
          var u = map[btn.getAttribute('data-variant')];
          if (!u || !img) return;
          img.src = sized(u, 1200); img.removeAttribute('srcset'); img.removeAttribute('sizes');
          if (timg) { timg.src = sized(u, 200); timg.removeAttribute('srcset'); timg.removeAttribute('sizes'); }
          if (simg) { simg.src = sized(u, 100); simg.removeAttribute('srcset'); }
          if (thumb && !slide.classList.contains('is-active')) thumb.click();
        }
        plans.forEach(function(b){ b.addEventListener('click', function(){ apply(b); }); });
        var cur = Array.prototype.filter.call(plans, function(b){ return b.getAttribute('aria-checked') === 'true'; })[0];
        if (cur) apply(cur);
      }).catch(function(){});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVariantImages); else initVariantImages();
  document.addEventListener('shopify:section:load', initVariantImages);
})();
